<template>
  <el-row class="delivery_framework">
    <el-table :data="orderList" style="width: 100%" @selection-change="selectOrder">
      <template slot="empty">
        <span class="emptyText">暂无待出库订单信息</span>
      </template>
      <el-table-column align="center" type="selection" width="18">
      </el-table-column>
      <el-table-column align="left" width="400">
        <template slot="header">
          <el-row>
            <el-button-group>
              <el-button class="small_button" size="small" type="primary" @click="clickAllOrder">商品出库</el-button>
            </el-button-group>
          </el-row>
        </template>
        <template slot-scope="scope">
          <el-card class="order_card" shadow="hover">
            <el-row>
              <div class="clearfix">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="24">
                      <p class="order_title">待出库订单&nbsp;#{{ scope.row.id.substring(scope.row.id.length - 4) }}</p>
                    </el-col>
                    <el-col :span="24">
                      <p class="order_address">{{ scope.row.addressDetail + '--' + scope.row.addressNote}}</p>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-button class="order_status" type="text">
                    <span>进行中</span>
                  </el-button>
                </el-col>
              </div>
            </el-row>
            <el-divider></el-divider>
            <order-card :orderInfo=scope.row></order-card>
            <el-row type="flex" justify="center">
              <el-col :span="5">
                <el-button class="button" type="primary" @click="clickOrder(scope.row)">确认出库</el-button>
              </el-col>
              <el-col :span="5">
                <el-button class="button" @click="rePrint(scope.row)">补打订单</el-button>
              </el-col>
            </el-row>
          </el-card>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageData.currentPage"
                   :page-sizes="[1,10, 50, 100]"
                   :page-size="pageData.pageSize"
                   :total="pageData.totalSize"
                   layout="sizes, prev, pager, next, total"
                   @size-change="changeSize"
                   @current-change="changeCurrent">
    </el-pagination>
  </el-row>
</template>

<script>
import OrderCard from "../OrderCard.vue"
import DataUntils from "@/utils/data.js";
import startPrint from "../../../../store/print"

export default {
  name: "PendingDelivery",
  components: {
    OrderCard,
  },
  data() {
    return {
      orderStatus: {
        status: "待出库"
      },
      orderList: [],
      orderSelection: [],
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条目个数
        totalSize: 0, //总条目数
      },
      orderCnt: 0,  // 新处理过的订单
    };
  },
  created() {
    this.getOrderList();
  },
  mounted() {
  },
  watch: {
    // orderList: {
    //   handler: function () {
    //     this.$emit('deliveryCount', this.orderList.length);
    //   }
    // }
    "pageData.totalSize"() {
      this.getOrderList();
      // this.$emit('deliveryCount', this.pageData.totalSize);
      // this.$emit('newReceiptCnt', this.orderCnt);
    }
  },
  methods: {
    getOrderList() {
      DataUntils
          .getOrderListByStatus({
            status: this.orderStatus.status,
            page:this.pageData.currentPage,
            pageSize: this.pageData.pageSize
          })
          .then((res) => {
            // console.log(res);
            this.orderList = res.orderList;
            //这个逻辑有问题，导致不好翻页
            // this.pageData = res.pageData;
            this.pageData.totalSize = res.pageData.totalSize;
          })
    },
    async clickOrder(val) {
      await DataUntils
          .deliverOrderByID({
            orderId: val.id
          });
      this.$notify({
        title: '订单出库通知',
        message: `订单#${val.id.substring(val.id.length - 4)}已出库`,
        duration: 3000
      });
      //逻辑1：页面静态处理订单，即处理一个订单之后，页面订单会少于10个
      //对于页面总订单量'deliveryCount'和总页数的维护，会变得复杂
      // this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
      //逻辑2：页面动态处理订单，即处理一个订单后，就求取改状态的所有订单，也可以控制页面停留在处理的页码
      //需要异步
      this.getOrderList();
      this.orderCnt = 1;
    },
    clickAllOrder() {
      if (this.orderSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'error'
        });
      } else {
        this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "success",
        })
            .then(() => {
              this.orderCnt = this.orderSelection.length;
              let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils
                    .deliverOrderByID({
                      orderId: this.orderSelection[i].id
                    });
                orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
              this.$notify({
                title: '订单出库通知',
                message: `${this.orderSelection.length}件订单已出库`,
                duration: 3000
              });
              this.getOrderList();
            });
      }
    },
    selectOrder(val) {
      this.orderSelection = val;
    },
    // 每页显示条目个数更改
    changeSize(pageSize) {
      this.pageData.pageSize = pageSize;
      this.pageData.currentPage = 1;
      this.getOrderList();
    },
    // 当前页数更改
    changeCurrent(currentPage) {
      this.pageData.currentPage = currentPage;
      this.getOrderList();
    },
    //补打订单
    async rePrint(data) {
      await DataUntils.judgeOrderStatus(data.id, '待出库', false)
      .then(() => {
        startPrint(data,false);
      })
    }
  },
};
</script>

<style>
@import "../../../../style/Order.css";
</style>
